import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAuthStore, useRegister} from "../stores/authStore";

const LoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({});
    const {login, loading, error} = useRegister();

    const validate = () => {
        let newErrors = {};

        // проверка email
        if (!email) {
            newErrors.email = "Введите email";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Неверный формат email";
        }

        // проверка пароля
        if (!password) {
            newErrors.password = "Введите пароль";
        } else if (password.length < 6) {
            newErrors.password = "Пароль должен быть не менее 6 символов";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        await login({email, password});

        if (useAuthStore.getState().token) {
            navigate("/detail/create/");
        }
    };

    const ErrorText = ({name}) =>
        errors[name] ? (
            <p className="text-xs text-red-600 mt-1">{errors[name]}</p>
        ) : null;

    return (
        <div
            style={{backgroundImage: `url(https://i.pinimg.com/originals/4f/46/3a/4f463a7eadcb4b6878e1131bea9539d8.jpg)`}}
            className={'relative z-20 bg-cover flex items-center min-h-[85vh]'}>
            <div className="md:w-2/5 mx-auto">
                <div
                    className="flex items-center justify-center rounded-2xl bg-white/45 backdrop-blur-md relative overflow-hidden">
                    <div className="p-8 rounded-lg shadow-md w-full">
                        <h2 className="md:text-2xl text-xl font-semibold mb-6 text-black/70">Вход</h2>

                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div>
                                <label htmlFor="email" className="block text-sm mb-1 text-black/70">Email</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    id="email"
                                    className="w-full border bg-white/30 rounded-md text-black/70 px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="email"/>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm mb-1 text-black/70">Password</label>
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    id="password"
                                    className="w-full border bg-white/30 rounded-md px-3 py-2 text-black/70 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="password"/>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-black/60 duration-300 text-white py-2 rounded-lg hover:bg-black transition"
                            >
                                {loading ? "Вход..." : "Войти"}
                            </button>
                            {error && <p className="text-red-600 text-sm mt-2">{error.detail}</p>}
                        </form>

                        <div className="mt-4 text-center flex md:flex-row flex-col md:justify-center md:gap-20">
                            <div>
                            <span className="text-[12px] md:text-sm font-semibold text-black/30">
                                Если у вас нету аккаунта.
                            </span>
                                <Link to={'/detail/sign/'}
                                      className="text-black/70 text-sm md:text-base hover:text-black block hover:underline">
                                    Зарегистрироваться
                                </Link>
                            </div>
                            <div>
                                <span className="text-[12px] md:text-sm font-semibold text-black/30">
                                Если забыли пароль.
                            </span>
                                <Link to={'/detail/reset/'}
                                      className="text-black/70 text-sm md:text-base hover:text-black block hover:underline">
                                    Сброс пароля
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
